import React from "react";
import "../../App.css";


export function Ui(props) {

  return <>
    <div id="info"><a href="impressum.html">Impressum und Datenschutz</a></div>
  </>;
}